import { useNavigate } from "react-router-dom";
import OlinMascot from "../../assets/olinCharaLogin.png";
import Logo from "../../assets/olinfull.png";
import FullsizeButton from "../../components/common/FullsizeButton";
import { IoArrowBack } from "react-icons/io5";
import { useEffect, useRef, useState } from "react";
import * as emoji from "node-emoji";
import HOC from "../../components/HOC";
import { useFormik } from "formik";
import { Info } from "@mui/icons-material";

const OtpConfirmation = () => {
  const navigate = useNavigate();
  const inputRefs = useRef([]);

  const [isMobileView, setIsMobileView] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    const otpString = newOtp.join("");
    formik.setFieldValue("otp", otpString);

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 4);
    if (/^\d+$/.test(pastedData)) {
      const newOtp = pastedData.split("").slice(0, 4);
      setOtp(newOtp);
      formik.setFieldValue("otp", newOtp.join(""));

      const lastFilledIndex = Math.min(newOtp.length - 1, 3);
      inputRefs.current[lastFilledIndex]?.focus();
    }
  };

  const handleResendOtp = () => {
    if (canResend) {
      // mutateResendOTP({
      //   email: email,
      //   type: type === "reset-password" ? 2 : 1,
      // });
      setCountdown(30);
      setCanResend(false);
      setOtp(["", "", "", ""]);
      formik.setFieldValue("otp", "");
      inputRefs.current[0]?.focus();
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      otp: "",
      //  type: type === "reset-password" ? 2 : 1,
      //  email: email || "",
      //  otp: "",
      //  type: type === "reset-password" ? 2 : 1,
    },
    // validationSchema: validationSchema,
    // onSubmit: (values) => {
    //   setErrorMessage("");
    //   mutateVerify(values);
    // },
  });

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [countdown]);

  return (
    <div className="bg-white relative">
      <FullsizeButton />
      <div className="flex flex-row justify-center h-screen">
        <div className="hidden md:order-last bg-cover lg:block lg:w-1/2">
          <div className="flex items-center h-full p-8 bg-white justify-center">
            <div className="w-[30vw] h-[30vw] flex justify-center object-cover items-center rounded-full p-8 bg-blue-100">
              <div className="p-16 bg-blue-300 rounded-full w-full h-full">
                <img
                  src={OlinMascot}
                  className="w-full h-full"
                  alt="Olin Maskot"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
          <div className="rounded-md p-4 lg:p-8 w-full h-fit">
            <div className="w-full flex items-center gap-4 lg:hidden text-xl">
              <div
                onClick={() => navigate(-1)}
                className="p-1 hover:bg-gray-200 rounded-full"
              >
                <IoArrowBack className="text-gray-500" />
              </div>
            </div>
            <p className="font-semibold text-primary-700 text-xl mt-8">
              Masukkan Kode OTP
            </p>
            <p className="my-6">
              Kode OTP telah dikirim ke{" "}
              <span className="font-semibold">willy@gmail.com</span>. Silahkan
              masukkan kode untuk melanjutkan.
            </p>

            {/* <form onSubmit={formik.handleSubmit} className="space-y-6"> */}
            <div className="flex justify-center gap-3 mb-6">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  className="w-12 h-12 text-xl text-center border-2 border-gray-300 rounded-xl focus:border-secondary focus:outline-none transition-colors duration-200"
                  autoFocus={index === 0}
                />
              ))}
            </div>

            {errorMessage && (
              <div className="w-full flex justify-end">
                {errorMessage &&
                  errorMessage !== "" &&
                  errorMessage !== null && (
                    <div className="flex items-center gap-2 bg-red-100 py-1 px-2 rounded-sm">
                      <div className="w-4 flex items-center justify-center">
                        <Info className="text-error" size={14} />
                      </div>
                      <p className="text-sm text-red-800">{errorMessage}</p>
                    </div>
                  )}
              </div>
            )}

            {/* <div className="w-full flex justify-end">
              <p className="text-sm text-gray-600 mb-2">
                Tidak menerima kode?{" "}
                {canResend ? (
                  <button
                    onClick={handleResendOtp}
                    className="text-primary font-semibold cursor-pointer hover:underline"
                  >
                    Kirim Ulang Kode
                  </button>
                ) : (
                  <span className="text-gray-500">
                    Kirim Ulang Kode ({countdown.toString().padStart(2, "0")})
                  </span>
                )}
              </p>
            </div> */}

            <button
              type="submit"
              // disabled={isPending || formik.values.otp.length !== 4}
              className="bg-secondary text-white w-full tracking-wide font-semibold p-3 rounded-lg hover:bg-success shadow-lg traansform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-default"
            >
              {/* {isPending ? "Memverifikasi..." : "Verifikasi"} */}
              Verifikasi
            </button>
            {/* </form> */}

            <hr className="my-6 lg:my-10" />
            <div className="text-center text-md flex flex-col justify-center gap-2">
              <p className="">Belum menerima kode? </p>
              {canResend ? (
                <button
                  onClick={handleResendOtp}
                  className="text-primary font-semibold cursor-pointer hover:underline"
                >
                  Kirim Ulang Kode
                </button>
              ) : (
                <p>
                  Kirim ulang dalam ({countdown.toString().padStart(2, "0")})
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Snackbar
        open={statusCode || (errorMessage !== "" && !passwordError)}
        autoHideDuration={5000}
        onClose={() => {
          setStatusCode(false);
          setErrorMessage("");
        }}
        message={errorMessage}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      /> */}
    </div>
  );
};

export default HOC(OtpConfirmation, "guest-only");
